import styled from 'styled-components';

const HeaderWrapperStyles = styled.div`
  order: 1;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 6px 0px;
  grid-template-areas:
    'Title Action'
    'Subtitle Action';
`;

export default HeaderWrapperStyles;
